import { useLanguage } from "@/context/LanguageContext";
import { SITE } from "@/constants/site";
import { FadeUp, RevealLineInView, RevealImage } from "@/components/animations/Reveal";

export default function About() {
    const { t } = useLanguage();
    return (
        <section id="about" className="relative bg-white py-16 md:py-36" data-testid="about">
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
                    {/* Left: Chapter + image */}
                    <div className="lg:col-span-5 lg:sticky lg:top-32">
                        <FadeUp>
                            <div className="flex items-center gap-4 mb-8">
                                <span className="chapter-num text-lg">{t.about.chapter}</span>
                                <span className="h-[1px] flex-1 bg-gold/40" />
                                <span className="eyebrow">{t.about.eyebrow}</span>
                            </div>
                        </FadeUp>
                        <RevealImage
                            src={SITE.images.about}
                            alt="Salon"
                            className="rounded-3xl aspect-[4/5]"
                        />
                    </div>

                    {/* Right: heading + body */}
                    <div className="lg:col-span-7 lg:pt-4">
                        <h2 className="font-display text-ink leading-[0.98] text-4xl sm:text-5xl lg:text-6xl mb-10 tracking-tight">
                            <RevealLineInView delay={0}>{t.about.title.split(" ")[0]}</RevealLineInView>{" "}
                            <span className="serif-italic text-gold">
                                <RevealLineInView delay={0.15}>{t.about.title.split(" ").slice(1).join(" ")}</RevealLineInView>
                            </span>
                        </h2>

                        <FadeUp delay={0.1}>
                            <p className="text-ink/85 text-lg leading-relaxed mb-6 max-w-xl">
                                {t.about.body_1}
                            </p>
                        </FadeUp>
                        <FadeUp delay={0.2}>
                            <p className="text-ink/85 text-lg leading-relaxed mb-6 max-w-xl">
                                {t.about.body_2}
                            </p>
                        </FadeUp>
                        <FadeUp delay={0.3}>
                            <p className="text-ink/85 text-lg leading-relaxed mb-14 max-w-xl">
                                {t.about.body_3}
                            </p>
                        </FadeUp>

                        {/* Stats */}
                        <FadeUp delay={0.35}>
                            <div className="grid grid-cols-3 gap-8 pt-8 border-t border-gold/25">
                                {t.about.stats.map((s, i) => (
                                    <div key={i} data-testid={`about-stat-${i}`}>
                                        <div className="font-display text-4xl md:text-5xl text-ink">
                                            {s.n}
                                        </div>
                                        <div className="mt-2 text-xs tracking-[0.2em] uppercase text-ink/60">
                                            {s.l}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </FadeUp>
                    </div>
                </div>
            </div>
        </section>
    );
}
